module.exports = __webpack_public_path__ + "images/artist_640.9a33cd01c48ed3a417daee59f88de09b.png";